let freebie = {}
let freeItems = {}

class FreeProducts extends HTMLElement {
    constructor() {
        super();
        const products = this.querySelectorAll('.bundle-builder__gift')
        this.products = products

        this.initialize()
        products.forEach((item) => {
            item.addEventListener('click', () => this.handleProductClick(item))
        })
    }

    initialize() {
        const first = this.products[0]
        this.handleProductClick(first)
    }

    handleProductClick(item) {
        this.removeAllFreeItems()
        const id = item.dataset.id
        freeItems[id] = 1
        this.updateUI(item)
    }

    removeAllFreeItems() {
        this.products.forEach((item) => {
            item.classList.remove('checked')
            delete freeItems[item.dataset.id]
        })
    }

    updateUI(item) {
        item.classList.add('checked')
    }
}

customElements.define('free-products', FreeProducts)


// Change option selected
const label = document.querySelector('.dropdown__filter-selected')
const options = Array.from(document.querySelectorAll('.dropdown__select-option'))

options.forEach((option) => {
    option.addEventListener('click', () => {
        label.setAttribute('data-item-id', option.dataset.itemId)
        label.innerHTML = option.innerHTML
        handleFreebieClick()
    })
})

function handleFreebieClick() {
    const id = label.dataset.itemId
    freebie = {
        [id]: 1
    }
}

handleFreebieClick()

// Close dropdown onclick outside 
document.addEventListener('click', (e) => {
    const toggle = document.querySelector('.dropdown__switch')
    const element = e.target

    if (element == toggle) return;

    const isDropdownChild = element.closest('.dropdown__filter')

    if (!isDropdownChild) {
        toggle.checked = false
    }
})

// ON ADD CLICK
// const addToCartButton = document.querySelector('.bundle-builder__add')
// addToCartButton.addEventListener('click', handleAddToCart)
//
// function handleAddToCart() {
//     addToCartButton.classList.add('loading')
//
//     const data = {...bundle, ...freebie, ...freeItems}
//     console.table(data)
//
//     const host = 'https://beautybyearth.com/cart/'
//     const itemUrl = Object.keys(data).map((key) => key + ':' + data[key]).join(',')
//
//     console.log(host + itemUrl)
//
//     setTimeout(() => {
//         window.location.href = host + itemUrl;
//     }, 1000)
// }